import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addLiveBookmark } from './../../../../../redux/actions/searchActions';
import { jsonParseTraslation } from 'utils/getTranslation';
import { getEventTimeIndicator } from './../../../utils';

//ESTE HOOK TE RETORNA LA ETIQUETA DONDE TE MUESTRA EL ESTADO DEL EVENTO,
//YA EMITIDO, MAS TARDE O AHORA Y EN CASO DE SER EVENTO FUTURO TE RETORNA LA FECHA
//EN EVENTO PRESENTE TE RETORNA EL BOOKMARK DEL PROGRESO
export const useGetStatusConfig = (beginTime, endTime, id ) => {
  const [statusConfig, setStatusConfig] = useState({
    statusLabel: null,
    futureEventDate: null,
  });
  const texts = useSelector(state => state.metadata.translations);
  const {
    playingLive_eventType_description_pastEvent_label,
    playingLive_eventType_description_pastEvent_background,
    playingLive_eventType_description_futureEvent_label,
    playingLive_eventType_description_futureEvent_background,
    playingLive_eventType_description_presentEvent_label,
    playingLive_eventType_description_presentEvent_background,
  } = jsonParseTraslation(texts);
  const dispatch = useDispatch();
  const isTimeSet = beginTime === undefined && endTime === undefined;

  const getStatusLabel = time => {
    switch (time) {
      case 'pastEvent':
        return (
          <label
            className={`live-info__status-event`}
            style={{
              backgroundColor: `${playingLive_eventType_description_pastEvent_background}`,
              minWidth:'74px'
            }}
          >
            {playingLive_eventType_description_pastEvent_label}
          </label>
        );
      case 'presentEvent':
        return (
          <label
            className="live-info__status-event"
            style={{
              backgroundColor: `${playingLive_eventType_description_presentEvent_background}`,
            }}
          >
            {playingLive_eventType_description_presentEvent_label}
          </label>
        );
      case 'futureEvent':
        return (
          <label
            className="live-info__status-event"
            style={{
              backgroundColor: `${playingLive_eventType_description_futureEvent_background}`,
              minWidth: '75px',
            }}
          >
            {playingLive_eventType_description_futureEvent_label}
          </label>
        );
      default:
        break;
    }
  };

  useEffect(
    () => {
      const eventTimeIndicator = getEventTimeIndicator(beginTime, endTime);
      const statusResut = getStatusLabel(eventTimeIndicator?.inTime);

      setStatusConfig({
        statusLabel: statusResut,
        futureEventDate: eventTimeIndicator?.dateToEvent
          ? eventTimeIndicator?.dateToEvent
          : null,
      });

      if (eventTimeIndicator?.bookmark)
        return dispatch(
          addLiveBookmark({
            id,
            bookmark: eventTimeIndicator?.bookmark,
          }),
        );
    },
    [isTimeSet],
  );

  return { ...statusConfig };
};
